export default __webpack_public_path__ + "31eb66c.png";